export default "__VITE_ASSET__DkDDUt6F__ 584w";